<template>
  <label :class="{ 'd-block': true, 'pb-1': true, 'red--text text--darken-1': error }"
         :aria-hidden="ggFor ? 'true' : 'false'"
         :for="ggFor">
    <slot></slot>
  </label>
</template>

<script>
export default {
  props: {
    error: {
      type: Boolean,
      required: false
    },
    ggFor: {
      type: String,
      required: false
    }
  }
}
</script>
